export default __webpack_public_path__ + "static/media/props.f95098c9.jpg";